module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "h1"
    }
  }), _c('a', {
    attrs: {
      "href": "#/04_preface#h2"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Preface")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/05_chapter01#h3"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 1        The Oldest Parish Churches")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/14_chapter02#h4"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 2        The King’s Wood and Lindrick")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/14_chapter02#h5"
    }
  }, [_vm._v("Roche Abbey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/14_chapter02#h6"
    }
  }, [_vm._v("Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/18_chapter024#h7"
    }
  }, [_vm._v("Coppicing")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/20_chapter026#h8"
    }
  }, [_vm._v("The Limes and Lindrick")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/23_chapter03#h9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 3        Tickhill: a Country Town")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter04#h10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 4        Monasteries and their Granges")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter04#h11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Roche Abbey")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/32_chapter04#h12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Cistercian Possessions")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter042#h13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Monk Bretton Priory")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/34_chapter042#h14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Other Granges")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter05#h15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 5        Timber-Framed Barns")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/41_chapter05#h16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Whiston Long Barn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/43_chapter052#h17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gunthwaite Barn")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/45_chapter054#h18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cruck Barns")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter06#h19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 6        Pennine Farms")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/49_chapter06#h20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Belle Clive and Langsett")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/51_chapter062#h21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thurlstone township")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/55_chapter066#h22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Midhope")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/58_chapter07#h23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 7        Tankersley Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter08#h24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 8        Wombwell Ings and Old Moor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/67_chapter08#h25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter082#h26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Old Surveys and Maps of the Wombwell Ings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/69_chapter082#h27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Meadow management and the Bulling Dike")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/73_chapter086#h28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Old Moor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/75_chapter088#h29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Later Changes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/76_chapter09#h30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 9        The Transformation of Inclesmoor")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/80_chapter094#h31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Modern Drainage and Peat Workings")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/83_chapter097#h32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Humberhead Peatlands National Nature Reserve")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter10#h33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 10      The Old Halls of Worsbrough")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/84_chapter10#h34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Houndhill")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/86_chapter102#h35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swaithe Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/88_chapter104#h36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rockley Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/90_chapter106#h37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Worsbrough Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/93_chapter11#h38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 11      Bricks and Pantiles")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/102_chapter12#h39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 12      On the Limestone North of the Don")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/102_chapter12#h40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Late Medieval Decay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/104_chapter122#h41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Estate Villages")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/106_chapter124#h42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gentry Halls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/108_chapter126#h43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Coal Mining")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/111_chapter13#h44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 13      Cannon Hall and its Park")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/111_chapter13#h45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Spencer Family")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/113_chapter132#h46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Charcoal Iron Trade")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/120_chapter14#h47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 14      Wentworth Castle")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/124_chapter144#h48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Second Earl")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/128_chapter148#h49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Vernon-Wentworths")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/128_chapter148#h50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Present Day")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/129_chapter15#h51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 15      Inland Waterways")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/129_chapter15#h52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bawtry and the River Idle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/131_chapter152#h53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Doncaster and the Dun Navigation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/133_chapter154#h54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Dearne & Dove and Barnsley Canals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/138_chapter16#h55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 16      Wentworth and Elsecar")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/138_chapter16#h56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Wentworth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/142_chapter164#h57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Elsecar")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/147_chapter17#h58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 17      The Rivelin Valley")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/149_chapter172#h59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rivelin Chase")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/149_chapter172#h60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Woods")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/151_chapter174#h61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Water Mills")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/153_chapter176#h62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Parliamentary enclosure")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/156_chapter18#h63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 18      Nonconformist Chapels")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/165_chapter19#h64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 19      Coal Mining")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/167_chapter192#h65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Working Conditions in Coal Mines, 1850–1914")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/173_chapter20#h66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Chapter 20      A Miscellany")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/173_chapter20#h67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Barnburgh dovecote")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/175_chapter202#h68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Village Schools")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/179_chapter206#h69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hellaby Hall")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/181_chapter208#h70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("New Mill Bridge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/183_chapter2010#h71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Catcliffe glasshouse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/185_chapter2012#h72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thurlstone weaving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/188_notes#h73",
      "title": "Link target outside of Sample"
    }
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Notes")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21c438d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/03_contents.vue
// module id = 66
// module chunks = 0